var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"icon",attrs:{"src":_vm.icon},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }